import { useEffect } from "react";
import { Link } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ENROLLMENT_YEAR } from "./documentConfig";
import "./formularios.css";

const documents = [
  {
    href: "/formularios/documentacion-completa",
    title: "Documentación completa",
    label: "Formulario único · Solicitud + Anexo",
    description: "Cargá los datos una sola vez y descargá ambos documentos juntos o por separado.",
  },
];

export default function Formularios() {
  useEffect(() => {
    window.document.title = `Formularios de inscripción ${ENROLLMENT_YEAR} | Sagrado Corazón`;
  }, []);

  return (
    <main className="formularios">
      <Container maxWidth="md">
        <header className="formularios__header">
          <Typography className="formularios__eyebrow" component="p">
            Instituto Sagrado Corazón
          </Typography>
          <Typography component="h1" variant="h2" fontWeight="bold">
            Documentación de inscripción {ENROLLMENT_YEAR}
          </Typography>
          <Typography component="p">Completalo en línea, descargá el PDF para imprimirlo y firmarlo a mano.</Typography>
        </header>

        <Stack className="formularios__list" component="section" aria-label="Documentos disponibles" spacing={2}>
          {documents.map((item) => (
            <Paper
              className="formularios__card"
              component={Link}
              to={item.href}
              elevation={0}
              key={item.href}
            >
              <DescriptionOutlinedIcon aria-hidden="true" className="formularios__card-icon" />
              <div>
                <Typography className="formularios__card-label" component="p">
                  {item.label}
                </Typography>
                <Typography component="h2" variant="h5" fontWeight="bold">
                  {item.title}
                </Typography>
                {item.description && <Typography component="p">{item.description}</Typography>}
                <span className="formularios__card-action">Completar formulario →</span>
              </div>
            </Paper>
          ))}
        </Stack>

      </Container>
    </main>
  );
}
